import { createFileRoute } from '@tanstack/react-router';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { SeparacaoMonitor } from '@/features/separacao/page/monitor/SeparacaoMonitor';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/separacao/monitor')({
    beforeLoad: () =>
        validateRoute({
            fintech: false,
            validatePermission: ({ upp_logistica }) => isPermissionParcialOrFull(upp_logistica),
        }),
    component: SeparacaoMonitor,
});
